import React from 'react';

export default function EmptyCartPopup({ show, onClose }: { show: boolean; onClose: () => void }) {
  if (!show) return null;
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff',
          padding: '24px',
          borderRadius: '12px',
          textAlign: 'center',
          maxWidth: '300px',
          width: '90%',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <i
          className="bi bi-cart-x"
          style={{ fontSize: '3rem', color: '#ff4d4f' }}
        ></i>
        <h3
          style={{
            margin: '16px 0 8px 0',
            fontSize: '1.2rem',
            fontWeight: 600,
            color: '#333',
          }}
        >
          Panier Vide
        </h3>
        <p
          style={{
            color: '#666',
            fontSize: '0.9rem',
            marginBottom: '24px',
          }}
        >
          Votre panier est vide, vous n'avez pas acc&egrave;s &agrave; cette page.
        </p>
        <button
          onClick={onClose}
          style={{
            background: '#ff4d4f',
            color: '#fff',
            border: 'none',
            padding: '10px 24px',
            borderRadius: '6px',
            fontWeight: 600,
            cursor: 'pointer',
            width: '100%',
          }}
        >
          Fermer
        </button>
      </div>
    </div>
  );
}
